import { makeNullSafeDomainGetter, areasWithCommercialInfoPageDomainSelector } from './common';

export const areasWithCommercialInfoPageSelector = makeNullSafeDomainGetter(areasWithCommercialInfoPageDomainSelector, 'getAreasWithCommercialInfoPage');
